import { render, staticRenderFns } from "./ConsumersView.vue?vue&type=template&id=98c0d7ce&scoped=true"
import script from "./ConsumersView.vue?vue&type=script&lang=js"
export * from "./ConsumersView.vue?vue&type=script&lang=js"
import style0 from "./ConsumersView.vue?vue&type=style&index=0&id=98c0d7ce&prod&scoped=true&lang=css"
import style1 from "./ConsumersView.vue?vue&type=style&index=1&id=98c0d7ce&prod&lang=css"
import style2 from "./ConsumersView.vue?vue&type=style&index=2&id=98c0d7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c0d7ce",
  null
  
)

export default component.exports